import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import { ResetDeliveryData, isNull } from "../../../components/common/Common";

function DeliverySearchEmptyResult() {
  const fileRef = useRef();
  const [varExcelProgress, setExcelProgress] = useState(false);

  //엑셀파일을 선택하기
  const onUploadExcelHandler = (e) => {
    fileRef.current.click();
  };

  //엑셀파일을 읽어오기
  const onSelectedFileHandler = (e) => {
    const fileBox = fileRef.current;
    if (fileBox.value === "" || !fileBox.files) return false;
    setExcelProgress(true);
    const file = fileBox.files[0];
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = (e) => {
      if (!e.target) {
        setExcelProgress(false);
        return;
      }
      console.log(e.target.result);
      const bufferArray = e.target.result;
      const fileInformation = XLSX.read(bufferArray, {
        type: "buffer",
        cellText: false,
        cellDates: true,
      });
      const sheetName = fileInformation.SheetNames[0];
      const rawData = fileInformation.Sheets[sheetName];
      const datas = XLSX.utils.sheet_to_json(rawData);
      console.log(datas);
      if (datas?.length === 0) {
        setExcelProgress(false);
        alert("읽어들일 정보가 존재하지 않습니다. 다른 파일을 선택하세요.");
        return false;
      }
      ReadExcelFileData(datas);
    };
  };
  //읽어드린 엑셀파일정보 재가공
  const ReadExcelFileData = async (datas) => {
    let sendArray = [];
    console.log(datas);

    for (var i = 0; i < datas.length; i++) {
      let sendData = ResetDeliveryData(datas[i]);
      //운전자, 거래처
      if (!isNull(sendData["driver_name"]) || !isNull(sendData["cs_name"])) {
        await axios
          .post(
            `${process.env.REACT_APP_HOST}/_get_delivery_exceldata`,
            sendData
          )
          .then((res) => {
            const datas = res.data;
            if (datas.retvalue === 1) {
              if (datas.members?.length > 0) {
                const datam = datas.members[0];
                sendData["mem_idx"] = datam.mem_idx;
              } else {
                sendData["mem_idx"] = 0;
              }
              if (datas.customers?.length > 0) {
                const datac = datas.customers[0];
                sendData["cs_idx"] = datac.cs_idx;
              } else {
                sendData["cs_idx"] = 0;
              }
              sendArray.push(sendData);
            }
          });
      } else {
        sendArray.push(sendData);
      }
    }
    RegisterExcelFileData(sendArray);
  };
  //DB에 저장하기
  const RegisterExcelFileData = async (sendArray) => {
    for (var i = 0; i < sendArray.length; i++) {
      const sendData = { dataInfo: sendArray[i] };
      const res = await axios.post(
        `${process.env.REACT_APP_HOST}/_register_delivery`,
        sendData
      );
      console.log(i, res);
    }
    setExcelProgress(false);
    alert("배차정보를 등록하였습니다.");
    window.location.reload(); //리로드 페이지
  };

  return (
    <div className="main-box" style={{ marginTop: "30px" }}>
      <div className="btn-between">
        <div>
          <button onClick={(e) => onUploadExcelHandler(e)} className="btn line">
            EXCEL 읽어오기
          </button>
          <input
            type="file"
            ref={fileRef}
            onChange={(e) => onSelectedFileHandler(e)}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            style={{ display: "none" }}
          />
          {varExcelProgress ? (
            <span style={{ marginLeft: "20px" }}>작업중...</span>
          ) : null}
        </div>
        <div>
          <Link to={`/Admin/DeliveryDetail/0`} className="btn-danger">
            배차등록
          </Link>
        </div>
      </div>
    </div>
  );
}
export default DeliverySearchEmptyResult;
